















import { Component, Vue, Prop } from 'vue-property-decorator';
import { getAllPermission, allPermission } from '@/utils/permission';

type IPermissionInfo = IPermission.IResponse.IPermissionInfo;

@Component
export default class SelectPermission extends Vue {
  @Prop({default: () => []}) private excludePermissionIds!: string[];
  private defaultOptions: IPermissionInfo[] = [];
  get permissionOptions() {
    return this.defaultOptions.filter((permission) => !this.excludePermissionIds.includes(permission.id));
  }
  private created() {
    this.initOptions();
  }
  private initOptions() {
    if (allPermission.length === 0) {
      getAllPermission().then(() => {
        this.defaultOptions = allPermission;
      }).catch((err) => {
        this.$message.warning(err);
      });
    } else {
      this.defaultOptions = allPermission;
    }
  }
  // 处理选项改变
  private handleChange(value: string | string[]) {
    this.$emit('change', value);
  }
}
